<template>
	<v-dialog transition="scroll-x-reverse-transition" max-width="800">
		<template #activator="{ on, attrs }">
			<v-btn v-if="icon"
				color="secondary"
				icon
				small
				elevation="0"
				class="font-weight-bold"
				title="Edit User"
				v-bind="attrs"
				v-on="on">
				<v-icon>mdi-pencil</v-icon>
			</v-btn>

			<v-btn v-if="profile"
				text
				class="text-capitalize"
				v-bind="attrs"
				v-on="on">
				My Account
				<v-icon right>mdi-lock-check-outline</v-icon>
			</v-btn>
		</template>
		<template #default="dialog">
			<user-form :user="theUser" @success="dialog.value = false" @cancel="dialog.value = false" />
		</template>
	</v-dialog>
</template>
<script>
import UserForm from '@/Pages/Backend/Users/Form'
import api from '@/api'

export default {
	components: { UserForm },
	props: {
		user: {
			type: Object,
			default: () => {}
		},
		icon: {
			type: Boolean,
			default: false
		},
		profile: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			theUser: this.user
		}
	},
	mounted () {
		if(this.profile) {
			const method = 'GET'
			const data = {}

			const url = this.route('profile')

			return api({
				method,
				url,
				data
			}).then(response => {
				this.theUser = response.data
			})
		}
	},
	methods: {
		//
	}
}
</script>
